module.exports = __webpack_public_path__ + "img/31.efd9d72c.jpg";